import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import "./style.less";
import { Body1, Headline } from "src/Common/Theme/Typography";
import {
  infoIconsHeaderEng,
  infoIconsHeaderMy,
  infoIconsHeaderVn,
  infoIconsEng,
  infoIconsMy,
  infoIconsVn,
  infoIconsVnEng
} from "../../Constants/Constants";

import { isDesktop } from "isDesktop";
import { REGIONS } from "src/Services/RegionGetter/Constants";

export const HomePageInfoIconsSection = () => {
  // reducer
  const regionLanguage = useSelector((state) => state.RegionLanguageReducer);
  const { region, language } = regionLanguage;

  // state
  const [infoIconsHeaderText, setinfoIconsHeaderText] = useState("");
  const [infoIcons, setinfoIcons] = useState([]);

  // effect
  useEffect(() => {
    switch (true) {
      case language === REGIONS.malaysia:
        setinfoIconsHeaderText(infoIconsHeaderMy);
        setinfoIcons(infoIconsMy);

        break;
      case region === REGIONS.malaysia && language === "en":
        setinfoIconsHeaderText(infoIconsHeaderEng);
        setinfoIcons(infoIconsEng);

        break;
      case region === REGIONS.vietnam && language === "vn":
        setinfoIconsHeaderText(infoIconsHeaderVn);
        setinfoIcons(infoIconsVn);

        break;
      case region === REGIONS.vietnam && language === "en":
        setinfoIconsHeaderText(infoIconsHeaderEng);
        setinfoIcons(infoIconsVnEng);

        break;
      default:
    }
  }, [language, region]);

  return (
    <>
      {/* Desktop */}
      {isDesktop() ? (
        <div className="HomePageInfoIcons">
          <Headline
            shopee
            bold
            h1
            className="HomePageInfoIcons__ContentSubtitle"
          >
            {infoIconsHeaderText}
          </Headline>

          <div className="HomePageInfoIcons__OutterWrapper">
            <div className="HomePageInfoIcons__Container">
              {infoIcons.map((data, index) => (
                <div
                  key={index}
                  className="HomePageInfoIcons__Container__ImgIcons"
                >
                  <img
                    className="HomePageInfoIcons__Container__Img"
                    src={data.icon}
                    alt={data.description}
                    width={data.width}
                  />
                  <div>
                    <h2 className="HomePageInfoIcons__Container__Title">
                      {data.h2Text}
                    </h2>
                    <Body1 className="HomePageInfoIcons__Container__Text">
                      {data.bodyText}
                    </Body1>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="HomePageInfoIconsMobile">
          <div className="HomePageInfoIconsMobile__MobileBox">
            <Headline
              shopee
              bold
              h1
              className="HomePageInfoIconsMobile__contentTitle"
            >
              {infoIconsHeaderText}
            </Headline>
          </div>

          {infoIcons.map((data, index) => (
            <div
              className="HomePageInfoIconsMobile__FeaturesWrapper"
              key={index}
            >
              <div>
                <div className="HomePageInfoIconsMobile__FeatureLogo">
                  <img
                    src={data.icon}
                    alt={data.description}
                    width={data.width}
                  />
                  <Headline
                    h2
                    className="HomePageInfoIconsMobile__FeatureSubtitle"
                  >
                    {data.h2Text}
                  </Headline>
                  <p className="HomePageInfoIconsMobile__ContentInfo">
                    {data.bodyText}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};
